
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import FormWrapper from "@/components/FormWrapper.vue";
import Evrak from "@/classes/evrak/Evrak";
import {TakipEntity} from "@/entity/TakipEntity";
import TakipTalebiGenerator from "@/classes/evrak/TakipTalebi/TakipTalebiGenerator";
import KapakHesabi from "@/classes/evrak/KapakHesabi/KapakHesabi";
import KapakHesabiCalculator from "@/classes/evrak/KapakHesabi/KapakHesabiCalculator";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";
import HesapTablosuInfo from "@/components/infos/HesapTablosuInfo.vue";
import {TakipDurumu} from "@/enum/TakipDurumu";


@Component({
  components: {HesapTablosuInfo, FormWrapper}
})
export default class TakipHarcYokTaslak extends Vue{
  @Prop() takip!: TakipEntity;
  @Prop() hesapTarihi!:Date
  @Prop () dovizTahsilat!:number

  AlacakKalemiAlani = AlacakKalemiAlani;
  TakipDurumu = TakipDurumu;
  isLoadingEvrakData: boolean = false;
  kapakHesabi: KapakHesabi = new KapakHesabi();
  ttEvrak: Evrak = new Evrak();

  get faiz2Tutarlari() {
    const faiz2Tutarlari: any[] = [];

    if (this.kapakHesabi.paraBirimleri) {
      this.kapakHesabi.paraBirimleri.forEach((paraBirimi: any) => {
        const tutar = this.kapakHesabi.getTakipSonrasiAlacakKalemi(
            this.AlacakKalemiAlani.takipSonrasiFaiz,
            paraBirimi.id
        );
        const formatliTutar = this.$helper.tutarStr(tutar, paraBirimi);
        faiz2Tutarlari.push(formatliTutar);
      });
    }
    return faiz2Tutarlari;
  }

  async mounted() {
    // Takip durumuna göre hangi store kullanılacağına karar ver
    const isAcilmamis = this.takip?.takip_durumu === this.TakipDurumu.acilmamis;

    // İlgili store'dan borçlu verilerini al
    const borclular = isAcilmamis
      ? this.$store.state.takipEkle?.takipBorclular?.data
      : this.$store.state.takipDetay?.takip?.borclular;

    if (borclular && Array.isArray(borclular) && borclular.length > 0) {
      this.isLoadingEvrakData = true;

      // Takip durumuna göre ilgili store'un action'ını çağır
      const storeName = isAcilmamis ? 'takipEkle' : 'takipDetay';
      await this.$store.dispatch(`${storeName}/loadBorcluVekillerVeTebligatlar`, borclular);

      // State'deki güncel borçlu verilerini takip objesine merge et
      this.mergeBorcluDataFromState();

      this.isLoadingEvrakData = false;
    }

    if (this.takip) {
      this.onTakipChange();
      this.calculateKapakHesabi()
    }
  }

  mergeBorcluDataFromState() {
    // Takip durumuna göre hangi store'dan veri çekileceğine karar ver
    const isAcilmamis = this.takip?.takip_durumu === TakipDurumu.acilmamis;

    // İlgili store'dan güncellenmiş borçlu verilerini al
    const stateBorclular = isAcilmamis
      ? this.$store.state.takipEkle?.takipBorclular?.data
      : this.$store.state.takipDetay?.takip?.borclular;

    if (!stateBorclular || !this.takip?.borclular) return;

    this.takip.borclular.forEach((takipBorclu: any) => {
      const stateBorclu = stateBorclular.find((sb: any) => sb.id === takipBorclu.id);
      if (stateBorclu) {
        // State'deki yeni field'ları takip objesindeki borçluya ekle
        takipBorclu.vekiller = stateBorclu.vekiller || [];
        takipBorclu.tebligatlar = stateBorclu.tebligatlar || [];
        takipBorclu.borclu_bilgileri = stateBorclu.borclu_bilgileri || null;
        takipBorclu.adresler = stateBorclu.adresler || [];
        takipBorclu.varsayilan_adres = stateBorclu.varsayilan_adres || null;
      }
    });
  }

  @Watch("takip")
  onTakipChange() {
    let takipTalebiGenerator = new TakipTalebiGenerator()
    takipTalebiGenerator.setTakip(this.takip);
    this.ttEvrak = takipTalebiGenerator.getTakipTalebiEvrak();
    this.calculateKapakHesabi()
  }
  calculateKapakHesabi() {
    if (this.takip.id) {
      let kapakHesabiCalculator: KapakHesabiCalculator = new KapakHesabiCalculator();
      kapakHesabiCalculator.setTakip(this.takip);
      this.kapakHesabi = kapakHesabiCalculator.calculateKapakHesabi();
      this.kapakHesabi.alacakKalemiAlanlari.sort(function (a, b) {
        return a - b;
      });
      this.kapakHesabi.takipSonrasialacakKalemiAlanlari.sort(function (a, b) {
        return a - b;
      });
    }
  }

  print() {
    this.$helper.printComponent('takipHarcYokTaslak');
  }
}
